export default "__VITE_ASSET__10926f34__"